const customStyles = {
    control: (provided, state) => ({
      ...provided,
      fontSize: "13px",
      minHeight: '36.5px',
      height: '36.5px',  
      borderRadius: '16px',
      // borderColor: '#cbd0dd',
      boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(13, 110, 253, 0.25)' : provided.boxShadow,
      '&:hover': {
        // borderColor: '#ced4da',
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: '37.5px', // Altura del contenedor de valor
      padding: '0 6px',
    }),
    input: (provided) => ({
      ...provided,
      margin: '0',
      padding: '0',
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: '37.5px', // Altura de los indicadores
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: '0 6px',
    }),
    clearIndicator: (provided) => ({
      ...provided,
      padding: '0 6px',
    }),
    option: (provided) => ({
      ...provided,
      fontSize: '13px', // Tamaño de la fuente de las opciones
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: '6px',
    }),
    };
  
  export default customStyles;